export default __webpack_public_path__ + "static/media/17.66b22b20.jpg";